import {Box} from "@mui/material";
import {ResponsiveStyleValue} from "@mui/system";
import React, {useState} from "react";
import {SnapshotHotel, SnapshotTheme} from "./digitalSigning.types";

interface Props {
    theme?: SnapshotTheme;
    hotel?: SnapshotHotel;
}

export interface SigningLogoImage {
    src: string;
    onError: () => void;
}

const LOGO_HEIGHT = {xs: 72, sm: 96};

export const useSigningLogo = ({theme, hotel}: Props): SigningLogoImage | undefined => {
    const src = theme?.logoUrl || hotel?.logoUrl;
    const [failedSrc, setFailedSrc] = useState<string>();
    return src && src !== failedSrc ? {src, onError: () => setFailedSrc(src)} : undefined;
};

export function SigningLogo({logo, hotel, height = LOGO_HEIGHT, align = 'center'}: {
    logo: SigningLogoImage;
    hotel?: SnapshotHotel;
    height?: ResponsiveStyleValue<number>;
    align?: 'center' | 'left';
}) {
    return (
        <Box
            component={'img'}
            src={logo.src}
            alt={hotel?.name?.trim() ?? ''}
            onError={logo.onError}
            sx={{
                display: 'block',
                mx: align === 'center' ? 'auto' : 0,
                height,
                maxWidth: '70%',
                objectFit: 'contain',
                objectPosition: align === 'center' ? 'center' : 'left center',
            }}
        />
    );
}

function SigningHeader({theme, hotel}: Props) {
    const logo = useSigningLogo({theme, hotel});
    if (!logo) return null;

    return (
        <Box component={'header'} sx={{textAlign: 'center', mb: {xs: 3, sm: 4}}}>
            <SigningLogo logo={logo} hotel={hotel}/>
        </Box>
    );
}

export default SigningHeader;
